import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import useLoadScripts from '../utils/useLoadScript';
import { MetaTagComponent, MetaTags } from '../utils/MetaTags';

function PrivacyPage() {
  useLoadScripts([
    '/assets/js/jquery-3.7.1.min.js',
    '/assets/js/jquery-ui.js',
    '/assets/js/moment.min.js',
    '/assets/js/bootstrap.min.js',
    '/assets/js/swiper-bundle.min.js',
    '/assets/js/waypoints.js',
    '/assets/js/jquery.counterup.min.js',
    '/assets/js/wow.min.js',
    '/assets/js/jquery.nice-select.min.js',
    '/assets/js/jquery.marquee.min.js',
    '/assets/js/gsap.min.js',
    '/assets/js/ScrollTrigger.min.js',
    '/assets/js/ScrollSmoother.min.js',
    '/assets/js/SplitText.min.js',
    '/assets/js/jquery.fancybox.min.js',
    '/assets/js/three.js',
    '/assets/js/hover-effect.umd.js',
    '/assets/js/custom.js',
  ]);

  // Premium Styles
  const containerStyle = {
    maxWidth: "900px",
    margin: "120px auto",
    padding: "60px",
    fontFamily: "'Inter', 'Poppins', sans-serif",
    backgroundColor: "#ffffff",
    borderRadius: "24px",
    boxShadow: "0 20px 50px rgba(0,0,0,0.04)",
    border: "1px solid #f0f0f0",
  };

  const sectionStyle = {
    marginBottom: "40px",
    paddingBottom: "20px",
    borderBottom: "1px solid #f9f9f9",
  };

  const headingStyle = {
    fontSize: "42px",
    fontWeight: "700",
    letterSpacing: "-1px",
    marginBottom: "20px",
    color: "#111",
    textAlign: "center"
  };

  const subHeadingStyle = {
    fontSize: "24px",
    fontWeight: "600",
    marginBottom: "16px",
    color: "#1a1a1a",
    display: "flex",
    alignItems: "center",
  };

  const textStyle = {
    fontSize: "16px",
    lineHeight: "1.8",
    color: "#4b5563", // Slate gray for better readability
    fontWeight: "400",
  };

  const listStyle = {
    ...textStyle,
    paddingLeft: "25px",
    marginTop: "10px",
  };

  const badgeStyle = {
    display: "inline-block",
    padding: "6px 16px",
    backgroundColor: "#f3f4f6",
    borderRadius: "50px",
    fontSize: "13px",
    fontWeight: "600",
    color: "#6b7280",
    marginBottom: "20px",
    textTransform: "uppercase",
    letterSpacing: "1px"
  };

  return (
    <div id="smooth-wrapper">
      <div id="smooth-content">
        <MetaTagComponent 
          pageTitle={MetaTags.privacy.title}
          pageDescription={MetaTags.privacy.description}
          pageKeywords={MetaTags.privacy.keywords}
        />
        <Header />

        <main style={{ backgroundColor: "#fafafa", overflow: "hidden", padding: "20px" }}>
          <div style={containerStyle} className="wow fadeInUp" data-wow-delay="0.2s">
            
            <div style={{ textAlign: "center", marginBottom: "50px" }}>
              <span style={badgeStyle}>Legal Compliance</span>
              <h1 style={headingStyle}>Privacy Statement</h1>
              <p style={{ ...textStyle, fontSize: "18px", color: "#9ca3af" }}>
                Effective Date: April 2026
              </p>
            </div>

            <div style={sectionStyle}>
              <p style={textStyle}>
                This Statement applies for <strong>Insight Wide</strong>, its affiliates and related
                entities (collectively, "Insight Wide"). We value your privacy and ensure that personal information
                is handled securely and responsibly in accordance with applicable laws.
              </p>
            </div>

            <div style={sectionStyle}>
              <h2 style={subHeadingStyle}>1. Personal Information We Collect</h2>
              <p style={textStyle}>
                We collect personal information relevant to your relationship with
                Insight Wide including customers, employees, suppliers, and partners. This ensures a seamless 
                integration with our CRM and analytics tools.
              </p>
            </div>

            <div style={sectionStyle}>
              <h2 style={subHeadingStyle}>2. What is Personal Information?</h2>
              <p style={textStyle}>
                Personal Information refers to any data that can identify an
                individual directly or indirectly—such as names, contact details,
                or unique digital identifiers.
              </p>
            </div>

            <div style={sectionStyle}>
              <h2 style={subHeadingStyle}>3. How We Use Information</h2>
              <p style={textStyle}>
                Insight Wide uses personal data to provide services, support users,
                deliver training, and improve user experience. We use these insights to 
                optimize business growth for our clients.
              </p>
            </div>

            <div style={sectionStyle}>
              <h2 style={subHeadingStyle}>4. Your Rights</h2>
              <p style={textStyle}>As a user, you hold the following rights regarding your data:</p>
              <ul style={listStyle}>
                <li style={{ marginBottom: "8px" }}>Access your personal data</li>
                <li style={{ marginBottom: "8px" }}>Request corrections to inaccurate information</li>
                <li style={{ marginBottom: "8px" }}>Request permanent deletion</li>
                <li style={{ marginBottom: "8px" }}>Object to specific data processing activities</li>
              </ul>
            </div>

            <div style={sectionStyle}>
              <h2 style={subHeadingStyle}>5. Data Protection & Security</h2>
              <p style={textStyle}>
                We employ industry-standard security measures, including <strong>AES-256 encryption</strong>, 
                advanced firewalls, and strict access controls to protect your information from unauthorized access.
              </p>
            </div>

            <div style={sectionStyle}>
              <h2 style={subHeadingStyle}>6. International Transfers</h2>
              <p style={textStyle}>
                Your data may be shared with trusted services globally. We ensure that all 
                third-party partners maintain strict data protection standards equivalent to our own.
              </p>
            </div>

            <div style={{ ...sectionStyle, borderBottom: "none", marginBottom: 0 }}>
              <h2 style={subHeadingStyle}>Contact Us</h2>
              <p style={textStyle}>
                For any privacy concerns or data requests, please contact the Insight Wide 
                Legal Team through our official support channels.
              </p>
            </div>

          </div>
        </main>

        <Footer />
      </div>
    </div>
  );
}

export default PrivacyPage;